'use client';

import { useSiteSettings } from '@/lib/CmsContext';
import { resolveFooterSocialLinks, SOCIAL_ICON_LABELS } from '@/lib/socialIcons';

function socialHandle(item) {
  const platform = SOCIAL_ICON_LABELS[item.icon] || item.icon;
  const label = String(item.label || '').trim();
  if (label && label.toLowerCase() !== String(platform).toLowerCase()) {
    return label;
  }
  try {
    const u = new URL(item.url);
    const path = u.pathname.replace(/\/$/, '').split('/').filter(Boolean).pop();
    if (path) {
      return path.startsWith('@') ? path : `@${decodeURIComponent(path)}`;
    }
  } catch {
    /* ignore */
  }
  return '';
}

/**
 * @param {{ section?: import('@/types/cms').SocialLinksBarPageSection }} props
 */
export default function SocialLinksBar({ section = {} }) {
  const { socialLinks } = useSiteSettings();
  const items = resolveFooterSocialLinks(socialLinks);

  const eyebrow = section.eyebrow || 'Слідкуйте за нашими роботами';
  const title = section.title || 'Ми є скрізь';
  const highlight = section.title_highlight || 'де потрібно';

  if (!items.length) return null;

  return (
    <section className="bg-background py-12 lg:py-16 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-2">
              {eyebrow}
            </p>
            <h2 className="text-2xl sm:text-3xl font-black text-foreground">
              {title}{' '}
              {highlight ? <span className="text-gold">{highlight}</span> : null}
            </h2>
          </div>

          <div className="flex flex-wrap gap-3">
            {items.map((item) => {
              const platform = SOCIAL_ICON_LABELS[item.icon] || item.icon;
              const handle = socialHandle(item);
              return (
                <a
                  key={`${item.icon}-${item.url}`}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2.5 border border-border text-foreground px-4 py-2.5 rounded-full text-sm transition-all duration-200 hover:border-gold hover:text-gold"
                >
                  <item.Icon className="w-4 h-4 shrink-0" />
                  <span className="font-semibold">{platform}</span>
                  {handle ? (
                    <span className="text-muted-foreground font-normal">{handle}</span>
                  ) : null}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
